export default __webpack_public_path__ + "static/media/mitter.4b160b5b.svg";